var render, staticRenderFns
import script from "./StatisticChart.vue?vue&type=script&lang=js"
export * from "./StatisticChart.vue?vue&type=script&lang=js"
import style0 from "./StatisticChart.vue?vue&type=style&index=0&id=a3c28618&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports